/* ==========================================================================
   Homellence – Warenkorb: Menge ändern, Position entfernen
   ========================================================================== */
(function () {
  'use strict';

  var HL = (window.HL = window.HL || {});
  var busy = false;

  function root() {
    return document.querySelector('[data-hl-cart-body]');
  }

  function setBusy(state) {
    busy = state;
    var node = root();
    if (node) node.setAttribute('aria-busy', state ? 'true' : 'false');
  }

  function change(line, quantity, restoreFocusTo) {
    if (busy) return;
    setBusy(true);

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: 'hl-cart-drawer,hl-header',
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        HL.applyCartSections(data.sections);
        if (typeof HL.updateCartCount === 'function') HL.updateCartCount(data.item_count);
        restoreFocus(restoreFocusTo, line);
      })
      .catch(function () {
        /* Bei einem Fehler bleibt der bisherige Stand stehen. */
      })
      .finally(function () {
        setBusy(false);
      });
  }

  /* Nach dem Austausch wieder an dieselbe Stelle springen. */
  function restoreFocus(kind, line) {
    if (!kind) return;
    var node = root();
    if (!node) return;
    var item = node.querySelector('[data-hl-cart-item][data-line="' + line + '"]');
    var target = item
      ? item.querySelector(kind === 'input' ? '[data-hl-qty-input]' : '[data-hl-cart-remove]')
      : node.querySelector('[data-hl-drawer-close], a, button');
    if (target) target.focus();
  }

  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-hl-qty-step]');
    if (step) {
      var item = step.closest('[data-hl-cart-item]');
      var input = item.querySelector('[data-hl-qty-input]');
      var next = Math.max(0, parseInt(input.value, 10) + parseInt(step.getAttribute('data-hl-qty-step'), 10));
      input.value = next;
      change(parseInt(item.getAttribute('data-line'), 10), next, 'input');
      return;
    }

    var remove = event.target.closest('[data-hl-cart-remove]');
    if (remove) {
      var row = remove.closest('[data-hl-cart-item]');
      change(parseInt(row.getAttribute('data-line'), 10), 0, null);
    }
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-hl-qty-input]')) return;
    var item = event.target.closest('[data-hl-cart-item]');
    var value = Math.max(0, parseInt(event.target.value, 10) || 0);
    change(parseInt(item.getAttribute('data-line'), 10), value, 'input');
  });
})();
